import React from 'react'
import { styled } from '@mui/system';
import { Typography, Button, useTheme } from '@mui/material';
import { categorySumForMonth, categorySumForYear, formatCurrency } from '../../main/resources/CalcRessources';
import { useUser } from '../../@common/contexts/UserContext';
import { useEntry } from '../../@common/contexts/EntryContext';
import { useAppContext } from '../../@common/contexts/AppContext';
import Icon from '../../Icon';
import { expandAnimation } from '../../@common/theme/Theme';
import { makeTimeStamp } from '../../overview/resources/helpers';
import TransactionIcon from '../../transactions/components/TransactionIcon';
import { BlockType, CategoryType } from '../../main/resources/UserResources';

const BlockContainer = styled('div')(({ theme }) => ({
    position: "relative",
    maxWidth: "400px",
    margin: theme.spacing(4,"auto"),
    padding: theme.spacing(0,2)
 
     }
   ));

   const CustomRow = styled('div')(({ theme }) => ({
    position: "relative",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(1, 2, 1, 1),
    borderRadius: '7px',
    margin: theme.spacing(1.5, 0),
 
     }
   ));

type MonthyTableType = {
    blockOfInterest : BlockType;
    yearOfInterest: number;
}

const YearlyTable = ({blockOfInterest, yearOfInterest} : MonthyTableType) => {
    const {user, currentHousehold, blocks} = useUser();
    const {allEntries} = useEntry();
    const theme = useTheme();
    const blockIndex = blocks.indexOf(blockOfInterest);
    const {shadowStyle, darkMode} = useAppContext();


    const thisTimeStamp = makeTimeStamp(yearOfInterest,11);

    const cats = blockOfInterest?.categories.filter((categ : CategoryType) => {
      if (categ.status === "deleted" && Number(thisTimeStamp) >= Number(categ.deleted)) return false;
      if (Number(categ.created) > Number(thisTimeStamp)) return false;
      return true;
    })


    return (
        <>
        {blockOfInterest != null?
               <BlockContainer key={blockOfInterest.name}>
               <Typography sx={{fontSize: "18px", mb:2}}>{blockOfInterest.name}</Typography>
               {cats.map((cat : CategoryType, index: number) => {
                const thisSum = categorySumForYear(user.id, allEntries, cat.label, yearOfInterest);
                const thisAvg = thisSum/12;
                let time = (index + 1) * 400;

                 return(
                  <CustomRow key={cat.id + cat.label} sx={darkMode?[{animation: expandAnimation + " 500ms ease"}, shadowStyle, {backgroundColor: theme.palette.interactable}]:[{animation: expandAnimation + " 500ms ease"}, shadowStyle]}>
                  <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                  <TransactionIcon type='expense' categoryLabel={cat.label} blockIndex={blockIndex}/>
                     <Typography sx={{fontSize: "16px", ml: 2}}>{cat.label}</Typography>
                    </div>
                    <div style={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-end"}}>
                      <Typography sx={{fontSize: "16px"}}>{formatCurrency(thisSum,currentHousehold.currency)}</Typography>
                     <Typography sx={{fontSize: "16px"}}>Ø {formatCurrency(thisAvg,currentHousehold.currency)}</Typography>
                    </div>
                     </CustomRow>
                 )
               })
 
               }
             </BlockContainer>
             :
             <></>

        }    
       
        </>
  )
}

export default YearlyTable